import { render, staticRenderFns } from "./ProjectAdvertBannerCountdown.vue?vue&type=template&id=cd5f545c"
import script from "./ProjectAdvertBannerCountdown.vue?vue&type=script&lang=js"
export * from "./ProjectAdvertBannerCountdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports